module.exports = __webpack_public_path__ + "media/entities/58-5371e52a.png";